import { Region } from '@/types'
import { Heading } from '@big-red-group/storefront-common-ui'
import { RegionImage, Tile, TitleContainer, Wrapper } from './HomeRegions.styles'
import { useRouter } from 'next/router'
import { FullWidthSwiper, SwiperButtons, SwiperHeadingContainer, SwiperLeft, SwiperRight } from './Swiper.styles'
import { Swiper, SwiperSlide } from 'swiper/react'
import Container from './Container'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

const HomeRegions: React.FC<{ regions: Region[]; label: string }> = ({ regions, label }) => {
  const router = useRouter()
  const { lang } = router.query
  const defaultProperties = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)
  return (
    <Wrapper data-mcp-id="region-carousel">
      <Container spacing="XL">
        <SwiperHeadingContainer>
          <Heading size="XL">{label}</Heading>
          <SwiperButtons>
            <SwiperLeft className="prev"></SwiperLeft>
            <SwiperRight className="next"></SwiperRight>
          </SwiperButtons>
        </SwiperHeadingContainer>
      </Container>
      <FullWidthSwiper>
        <Swiper
          modules={[Navigation]}
          navigation={{ prevEl: '.prev', nextEl: '.next' }}
          breakpoints={{
            0: {
              spaceBetween: 16,
              slidesPerView: 'auto',
              loop: false,
            },
            720: {
              spaceBetween: 24,
              slidesPerView: 'auto',
              loop: true,
            },
          }}
        >
          {regions?.map(({ image, name, urlSegment }) => (
            <SwiperSlide className="fw-swiper-tile" key={urlSegment}>
              <Tile href={`${baseUrl}/${lang}/${urlSegment}`}>
                <LazyLoadComponent>
                  <RegionImage
                    style={{
                      backgroundImage: `url(${image})`,
                    }}
                  />
                </LazyLoadComponent>
                <Heading size="S" bold={false} spacing={false}>
                  {name}
                </Heading>
              </Tile>
            </SwiperSlide>
          ))}
        </Swiper>
      </FullWidthSwiper>
    </Wrapper>
  )
}

export default HomeRegions
